import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { Box } from '@mui/material';

export const StyledMainProduct = styled(Box)`
  display: flex;
  align-items: center;

  img {
    object-fit: contain;
    height: 24px;
    width: 24px;
  }

  .quantity {
    font-weight: 800;
    color: #ffff;
    font-size: 20px;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.8);
    line-height: normal;
    margin: 0;

    @media (width < ${breakpoints.mobileS}) {
      font-size: 16px;
    }
  }

  @media (min-width: 425px) {
    img {
      height: 24px;
      width: 24px;
    }

    .text {
      max-width: calc(100% - 95px);
    }
  }
`;

export const StyledSubProduct = styled(Box)<{ color: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  p {
    font-size: 14px;
    font-weight: 600;
    color: ${({ color }) => color};
  }

  img {
    aspect-ratio: 1/1;
    object-fit: contain;
    height: 20px;
  }

  @media (min-width: 375px) {
    .product-image-container .tooltip {
      height: 10px;
      width: 10px;
    }
  }
`;
